import { render } from "./Highlights.vue?vue&type=template&id=cb4cbdfa&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=cb4cbdfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4cbdfa"]])

export default __exports__